import { useNavigate } from 'react-router-dom'
import { isOwner, useApp } from '../lib/store'
import { AppBar } from '../components/AppBar'
import { BANKS } from '../lib/vietqr'

export function SettingsScreen() {
  const nav = useNavigate()
  const shop = useApp((s) => s.shop)
  const session = useApp((s) => s.session)
  const owner = isOwner(session?.role)
  const signOut = useApp((s) => s.signOut)

  const bank = BANKS.find((b) => b.bin === shop?.bankBin)

  return (
    <div className="screen">
      <AppBar title="Cài đặt" sub={shop?.name} onBack={() => nav('/')} />

      <div className="body">
        <h2 className="section-label">Quán</h2>
        <div className="list">
          {!owner && (
            <div className="row-btn" style={{ cursor: 'default' }}>
              <span className="row-icon" aria-hidden="true">
                🧑‍🍳
              </span>
              <span className="row-text">
                <b>{session?.name ?? 'Người bán hàng'}</b>
                <small>Bán hàng · không xem được doanh thu và thuế</small>
              </span>
            </div>
          )}

          {owner && (
            <>
          <button type="button" className="row-btn" onClick={() => nav('/settings/shop')}>
            <span className="row-icon" aria-hidden="true">
              🏠
            </span>
            <span className="row-text">
              <b>Thông tin quán</b>
              <small>
                {shop?.taxCode
                  ? `${shop.name} · MST ${shop.taxCode}`
                  : `${shop?.name ?? ''} · chưa khai mã số thuế`}
              </small>
            </span>
            <span aria-hidden="true">›</span>
          </button>

          <button type="button" className="row-btn" onClick={() => nav('/settings/bank')}>
            <span className="row-icon" aria-hidden="true">
              🏦
            </span>
            <span className="row-text">
              <b>Tài khoản nhận chuyển khoản</b>
              <small>
                {shop?.bankAccountNo ? `${bank?.short ?? ''} · ${shop.bankAccountNo}` : 'Chưa khai — chưa hiện được mã QR'}
              </small>
            </span>
            <span aria-hidden="true">›</span>
          </button>

          <button type="button" className="row-btn" onClick={() => nav('/settings/products')}>
            <span className="row-icon" aria-hidden="true">
              📋
            </span>
            <span className="row-text">
              <b>Sản phẩm</b>
              <small>Thêm, sửa giá, gán mã vạch</small>
            </span>
            <span aria-hidden="true">›</span>
          </button>

          <button type="button" className="row-btn" onClick={() => nav('/settings/staff')}>
            <span className="row-icon" aria-hidden="true">
              🧑‍🍳
            </span>
            <span className="row-text">
              <b>Người làm</b>
              <small>Thêm người bán, phân quyền</small>
            </span>
            <span aria-hidden="true">›</span>
          </button>
            </>
          )}

          <button type="button" className="row-btn" onClick={() => nav('/settings/printer')}>
            <span className="row-icon" aria-hidden="true">
              🖨
            </span>
            <span className="row-text">
              <b>Máy in bill</b>
              <small>Nối qua sigoPOS Print Agent</small>
            </span>
            <span aria-hidden="true">›</span>
          </button>
        </div>

        {owner && (
          <>
        <h2 className="section-label">Gói dịch vụ</h2>
        <button type="button" className="row-btn" onClick={() => nav('/settings/billing')}>
          <span className="row-icon" aria-hidden="true">
            💳
          </span>
          <span className="row-text">
            <b>{shop?.plan === 'Free' ? 'Đang dùng gói miễn phí' : 'Gói Quán nhỏ'}</b>
            <small>
              {shop?.plan === 'Free'
                ? '30 sản phẩm · 50 hoá đơn/ngày · không có báo cáo thuế'
                : 'Xem hạn dùng và gia hạn'}
            </small>
          </span>
          <span aria-hidden="true">›</span>
        </button>

          </>
        )}

        <button
          type="button"
          className="btn btn-danger-ghost wide"
          onClick={() => {
            void signOut()
            nav('/')
          }}
        >
          Đăng xuất khỏi máy này
        </button>
        <p className="note center-text">
          Đăng xuất sẽ xoá dữ liệu trên máy này. Đơn chưa gửi lên máy chủ sẽ mất — kiểm tra dấu
          "chờ gửi" ở màn hình chính trước khi đăng xuất.
        </p>
      </div>
    </div>
  )
}
